import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import css from '../css/lpview.m.css';
const factory = create({ theme }).properties();
export const LPView = factory(({ properties, middleware: { theme } }) => {
    const render_kids = (kids) => {
        return kids.map((kid) => {
            const { widget, jsondata } = kid;
            const params = { ...kid };
            delete params['widget'];
            if (jsondata) {
                params['data'] = JSON.parse(jsondata);
                delete params['jsondata'];
            }
            return w(widget, { ...params });
        });
    };
    const { classes = [], view, element = 'div', kids } = properties();
    const themeCss = theme.classes(css);
    return v(element, { key: view, xqa: `lpview ${view}`, classes: [themeCss.root, ...classes] }, render_kids(kids));
});
export default LPView;
